/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountSummary {
    getFixupPrototypeFunction() { return ServiceAccountSummary.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountSummary>): ServiceAccountSummary {
        let obj = Object.assign(new ServiceAccountSummary(), model);
        ServiceAccountSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountSummary>): ServiceAccountSummary {
        if (!model) return null;
        return ServiceAccountSummary.newInstance(<ServiceAccountSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountSummary) {
        if (!obj) return;

        models.ServiceAccountSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountSummary): boolean {
        Object.setPrototypeOf(obj, ServiceAccountSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.native_details) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.native_details);
        }
    }

    /**
     * Native details of the account
     */
    native_details: models.ServiceAccountNativeDetailsBase;

    /**
     * Status of the account
     */
    status: models.ServiceAccountStatus;

    /**
     * Number of accounts in the bucket
     */
    count: number;

}
